import * as Yup from "yup";
import { GET_VENDORS, GET_VENDOR_ACCOUNTS, GET_PROJECTS_LIST, GET_VENDOR_USERS } from "utils/graphql/services/live-classes/queries";

export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
            type: "configue",
        },
        {
            title: "Projects",
            value: "projectName",
            // type: "configue",
        },
        {
            title: "Vendor Users",
            value: "vendorUserName",
            type: "configue",
        },
        {
            title: "Vendor Email",
            value: "vendorEmail",
            type: "configue",
        }, 
        {
            title: "UserType",
            value: "userType",
            type: "configue",
        },
        {
            title: "IsActive",
            value: "isActive",
            type: "configue",
        },
        {
            title: "IsUsed",
            value: "isUsed",
            type: "configue",
        },
        
    ],
    secondaryData: [
        {
            title: "CreatedAt",
            value: "createdAt",
            type: "configue",
        },
        {
            title: "UpdatedAt",
            value: "updatedAt",
            type: "configue",
            name: "updatedAt"
        },
        {
            title: "Created By",
            value: "createdByName",
            type: "configue",
        },
        {
            title: "Updated By",
            value: "updatedByName",
            type: "configue",
            name: "updatedByName"
        }
    ],
};

export type VendorProjectUsers = {
    id: string;
    vendorId: string;
    vendorAccountId: string;
    projectIds: string[];
    userType: string;
    vendorUserId: string[];
    createdAt: string;
    updatedAt: string;
    createdById: string;
    updatedById: string;
    createdByName: string;
    updatedByName: string;
};

export const VenProUsersInitialValues: VendorProjectUsers = {
    id: "",
    vendorId: "",
    vendorAccountId: "",
    projectIds: [],
    userType: "",
    vendorUserId: [],
    createdAt: "",
    updatedAt: "",
    createdById: "",
    updatedById: "",
    createdByName: "",
    updatedByName: "",
};

export const VenProUsersMandatoryFields = [
    { id: "vendorId" },
    { id: "vendorAccountId" },
    { id: "projectIds" },
    { id: "userType" },
    { id: "vendorUserId" },
];

export const VenProUsersValidationSchema = Yup.object().shape({
});

export const VenProUsersProperties = [

    {
        id: "vendorId",
        type: "single-select-search",
        label: "Vendor *",
        keyValue: { label: "name", value: "id" },
        query: GET_VENDORS,
        gqlKey: "getVendors",
        dataKey: "vendors",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "vendorAccountId",
        type: "single-select-search",
        label: "Vendor Account *",
        keyValue: { label: "associatedDomainName", value: "id" },
        query: GET_VENDOR_ACCOUNTS,
        gqlKey: "getVendorAccounts",
        dataKey: "vendorAccounts",
        dependentOn: "vendorId",
        strictDependency: true,
        searchFieldKey: "associatedDomainName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "projectIds",
        type: "multi-select-search",
        label: "Project *",
        keyValue: { label: "name", value: "id" },
        query: GET_PROJECTS_LIST,
        gqlKey: "getProjects",
        dataKey: "projects",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
    },
    {
        id: "userType",
        type: "normal-select",
        label: "Zoom User Type",
        className: "select-styles",
        breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
        options: [
            { label: "Licensed", value: "Licensed" },
            { label: "Basic", value: "Basic" },
        ],
        hideNone: true,
    },
    {
        id: "vendorUserId",
        type: "multi-select-search",
        label: "Vendor Users *",
        keyValue: { label: "email", value: "id" },
        query: GET_VENDOR_USERS,
        gqlKey: "getVendorUsers",
        dataKey: "vendorUsers",
        searchFieldKey: "email",
        dependentOn: "userType",
        strictDependency: true,
        breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
        required: true,
    },

]

export function hasAtLeastOneValue(obj: any, keys: any[]) {
    return keys.some((key) => {
        const value = obj[key];
        return (
            value !== "" &&
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0) &&
            !(Array.isArray(value) && value.every(v => v === null))
        );
    });
}